import DelayRender from './DelayRender'

export default DelayRender
